(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bazaar-weekly-rug"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bazaar-weekly-rug')) {
    customElements.define('bazaar-weekly-rug', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || this.ready) return;
        this.ready = true;
        this.key = 'bg-weekly-rug:' + this.dataset.campaign;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelectorAll('[data-weekly-close]').forEach(button => button.addEventListener('click', () => this.close(), options));
        this.querySelector('[data-weekly-shop]').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('click', event => {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.close();
        }, options);
        this.dialog.addEventListener('close', () => this.restore(), options);
        document.addEventListener('shopify:section:select', event => {
          if (event.target.contains(this)) this.open(true);
        }, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden && this.dialog.open && !this.active()) this.close(); }, options);
        const schedule = () => {
          const elapsed = performance.now();
          this.timer = setTimeout(() => this.open(), Math.max(0, Number(this.dataset.delay) - elapsed));
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true, signal: this.abort.signal });
        else schedule();
      }
      active() {
        const now = Date.now();
        const start = Date.parse(this.dataset.start);
        const end = Date.parse(this.dataset.end);
        return Number.isFinite(start) && Number.isFinite(end) && now >= start && now < end;
      }
      seen() {
        try { return sessionStorage.getItem(this.key) === '1'; }
        catch { return window.bgWeeklySeen === this.key || document.cookie.split('; ').some(value => value === 'bg_weekly_seen=' + encodeURIComponent(this.key)); }
      }
      open(editorPreview = false) {
        if (!this.isConnected || this.dialog.open || !this.active()) return;
        if (!editorPreview && this.seen()) return;
        const otherOverlay = [...document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner')].some(element => element !== this.dialog && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none');
        if (document.hidden || otherOverlay) {
          this.timer = setTimeout(() => this.open(editorPreview), 1000);
          return;
        }
        this.previousFocus = document.activeElement;
        this.savedOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        if (!editorPreview) {
          try { sessionStorage.setItem(this.key, '1'); }
          catch { window.bgWeeklySeen = this.key; document.cookie = 'bg_weekly_seen=' + encodeURIComponent(this.key) + '; Path=/; SameSite=Lax; Secure'; }
        }
        this.expiryTimer = setTimeout(() => this.close(), Math.min(Date.parse(this.dataset.end) - Date.now(), 2147483647));
      }
      close() { this.dialog.close(); }
      restore() {
        clearTimeout(this.expiryTimer);
        if (this.savedOverflow !== undefined) document.documentElement.style.overflow = this.savedOverflow;
        this.savedOverflow = undefined;
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.dialog?.open) this.dialog.close();
        this.restore();
        this.abort?.abort();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
